import Fingerprint2 from 'fingerprintjs2'
import { useAsync } from 'react-use'
import styled from 'styled-components'
import Handle from '~/prix/react/components/handle'
import useDevice from '~/prix/react/hooks/device'
import systemAndInformationSchema from '../data/schema'
import StorageInformation from './storage'
import MemoryInformation from './memory'
import ServiceWorkerInformation from './serviceWorker'
import LayoutInformation from './layout'
import ResolutionScreenInformation from './resolution'
import Header from '~/components/card/header'
import useAPI from '~/prix/react/hooks/api'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 870px) {
    padding: 30px 0;
  }
`

const Container = styled.div`
  padding: ${({ theme }) => theme.padding(2)};
  background-color: #fff;
  margin-bottom: 1rem;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);

  h1 {
    margin: 0;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.darkText};
    padding-bottom: ${({ theme }) => theme.padding(2)};
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.padding(1)};
    & > :last-child {
      margin-bottom: ${({ theme }) => theme.padding(2)};
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      gap: ${({ theme }) => theme.padding(2)};
    }
  }

  .information {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.padding(2)};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: flex;
      flex-direction: column;
      gap: 0;
      align-items: start;
    }
  }

  h2 {
    margin: 0;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkText};
  }

  hr {
    border: 0.5px solid ${({ theme }) => theme.colors.lightGrey};
    margin: ${({ theme }) => theme.padding(2)} 0;
  }

  h3 {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.darkText};
  }
  span {
    color: ${({ theme }) => theme.colors.darkGrey};
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const SystemAndInfoScreen = () => {
  const { loading: deviceLoading, error: deviceError, value: deviceInfo } = useDevice()
  const { context } = useAPI()

  const userInformation = context.user

  const realIdentifierResult = useAsync(
    () =>
      new Promise<string>(resolve => {
        Fingerprint2.getV18((result: string) => {
          resolve(result)
        })
      }),
  )
  return (
    <Handle isLoading={deviceLoading}>
      <Wrapper>
        <Header title='Sistema e Informações' />
        <Container>
          <div className='container'>
            <h2>Usuário</h2>
            {systemAndInformationSchema.Usuário.properties.map((property, index) => (
              <div key={`${property}-${index}`} className='information'>
                <h3>{property.name}:</h3>
                <span>{eval(property.value) ?? 'Não encontrado'}</span>
              </div>
            ))}
            <hr />
            <h2>Dispositivo</h2>
            {systemAndInformationSchema.Dispositivo.properties.map((property, index) => (
              <div
                key={`${property}-${index}`}
                className='information'
                title={eval(property.value) ?? '-'}
              >
                <h3>{property.name}:</h3>
                <span>{eval(property.value) ?? '-'}</span>
              </div>
            ))}
            <hr />
            <ResolutionScreenInformation />
            <hr />
            <LayoutInformation />
            <hr />
            <ServiceWorkerInformation />
            <hr />
            <StorageInformation />
            <hr />
            <MemoryInformation />
          </div>
        </Container>
      </Wrapper>
    </Handle>
  )
}

export default SystemAndInfoScreen
